module.exports = __webpack_public_path__ + "6770e84eb309a3b7c0574fd1f9107a52.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/centene_2022_chart.png
// module id = 1648
// module chunks = 0